import { PermissionAdmin } from "../shared/models/admin.permission.model";
import { SinglePermissionModel } from "../shared/models/IPermission";
import { MapSinglePermissionModelToPermissionAdmin } from "../shared/mapper/single-permission-model-to-permission-admin.mapper";

export function getViewModleForPermissions(modle: SinglePermissionModel[]/*, isEditingMode: boolean*/, viewMode: number /*= ViewMode.FullAccess*/, groupPermission?: number[], tenantId?: number, isUkgDefaultGroup?: boolean): PermissionAdmin {
  let permissionAdmin = new PermissionAdmin();

  let systemConfig = modle.find(p => p?.permissionId === 1);
  let editClientURLCode = modle.find(p => p?.permissionId === 2);
  let viewEditLocalization = modle.find(p => p?.permissionId === 4);
  let dataImportExport = modle.find(p => p?.permissionId === 3);
  let viewEditLicensing = modle.find(p => p?.permissionId === 5);

  permissionAdmin.selectAllPermissionAdmin= {
    Selected:true,
    Enabled:true,
    Id:0,
    DisplayName:''
  }

  permissionAdmin.General = {
    selectAll: false,

    viewEditSystemConfiguration: MapSinglePermissionModelToPermissionAdmin(systemConfig, 1, viewMode, groupPermission),
    editClientURLCode: MapSinglePermissionModelToPermissionAdmin(editClientURLCode, 2, viewMode, groupPermission),
    viewEditLocalization: MapSinglePermissionModelToPermissionAdmin(viewEditLocalization, 4, viewMode, groupPermission),
    dataImportExport: MapSinglePermissionModelToPermissionAdmin(dataImportExport, 3, viewMode, groupPermission),
    viewEditLicensing: MapSinglePermissionModelToPermissionAdmin(viewEditLicensing, 5, viewMode, groupPermission)
  }


  let viewLocation = modle.find(p => p?.permissionId === 6);
  let addLocation = modle.find(p => p?.permissionId === 7);
  let editLocation = modle.find(p => p?.permissionId === 8);
  let activateDeactivateLocation = modle.find(p => p?.permissionId === 9);


  permissionAdmin.Location = {
    selectAll: false,

    viewLocations: MapSinglePermissionModelToPermissionAdmin(viewLocation, 6, viewMode, groupPermission),

    addLocations: MapSinglePermissionModelToPermissionAdmin(addLocation, 7, viewMode, groupPermission),


    editLocations: MapSinglePermissionModelToPermissionAdmin(editLocation, 8, viewMode, groupPermission),


    activateDeactivateLocations: MapSinglePermissionModelToPermissionAdmin(activateDeactivateLocation, 9, viewMode, groupPermission),



  }


  let viewAddEditProductCategories = modle.find(p => p?.permissionId === 10, viewMode);
  permissionAdmin.ViewAddEditDeleteProductCategory = {
    selectAll: false,

    viewAddEditDeleteProductCategory: MapSinglePermissionModelToPermissionAdmin(viewAddEditProductCategories, 10, viewMode, groupPermission),



  }



  let viewProductAndService = modle.find(p => p?.permissionId === 11);
  let addProductAndService = modle.find(p => p?.permissionId === 12);
  let editProductAndService = modle.find(p => p?.permissionId === 13);
  let editBasicProductAndService = modle.find(p => p?.permissionId === 68);
  let activateDeactivateProductsService = modle.find(p => p?.permissionId === 85);
  let deleteProductsService = modle.find(p => p?.permissionId === 86);

  permissionAdmin.ProductAndService = {
    selectAll: false,

    viewProductsServices: MapSinglePermissionModelToPermissionAdmin(viewProductAndService, 11, viewMode, groupPermission),


    addProductsServices: MapSinglePermissionModelToPermissionAdmin(addProductAndService, 12, viewMode, groupPermission),


    editProductsAndServices: MapSinglePermissionModelToPermissionAdmin(editProductAndService, 13, viewMode, groupPermission),

    editBasicProductAndServices: MapSinglePermissionModelToPermissionAdmin(editBasicProductAndService, 68, viewMode, groupPermission),

    activateDeactivateProductsServices : MapSinglePermissionModelToPermissionAdmin(activateDeactivateProductsService, 85, viewMode, groupPermission),

    deleteProductsServices: MapSinglePermissionModelToPermissionAdmin(deleteProductsService, 86, viewMode, groupPermission)
  }


  let viewPermission = modle.find(p => p?.permissionId === 14);
  let addPermission = modle.find(p => p?.permissionId === 15);
  let editPermission = modle.find(p => p?.permissionId === 16);
  let deletepermission = modle.find(p => p?.permissionId === 17);

  permissionAdmin.Groups = {
    selectAll: false,

    viewPermissionGroups: MapSinglePermissionModelToPermissionAdmin(viewPermission, 14, viewMode, groupPermission),
 

    addPermissionGroups: MapSinglePermissionModelToPermissionAdmin(addPermission, 15, viewMode, groupPermission),
 

    editPermissionGroups: MapSinglePermissionModelToPermissionAdmin(editPermission, 16, viewMode, groupPermission),


    deletePermissionGroups: MapSinglePermissionModelToPermissionAdmin(deletepermission, 17, viewMode, groupPermission),



  }



  let viewUsers = modle.find(p => p?.permissionId === 18);
  let addUsers = modle.find(p => p?.permissionId === 19);
  let editUsers = modle.find(p => p?.permissionId === 20);
  let deleteUsers = modle.find(p => p?.permissionId === 21);

  permissionAdmin.Users = {
    selectAll: false,

    viewUsers: MapSinglePermissionModelToPermissionAdmin(viewUsers, 18, viewMode, groupPermission),


    addUsers: MapSinglePermissionModelToPermissionAdmin(addUsers, 19, viewMode, groupPermission),


    editUsers: MapSinglePermissionModelToPermissionAdmin(editUsers, 20, viewMode, groupPermission),


    deleteUsers: MapSinglePermissionModelToPermissionAdmin(deleteUsers, 21, viewMode, groupPermission),


  }



  let viewMembers = modle.find(p => p?.permissionId === 22);
  let importMembers = modle.find(p => p?.permissionId === 23);

  permissionAdmin.Members = {
    selectAll: false,

    viewMembers: MapSinglePermissionModelToPermissionAdmin(viewMembers, 22, viewMode, groupPermission),


    importMembers: MapSinglePermissionModelToPermissionAdmin(importMembers, 23, viewMode, groupPermission),


  }

  let viewClients = modle.find(p => p?.permissionId === 24);
  let addClients = modle.find(p => p?.permissionId === 25);
  let changeClients = modle.find(p => p?.permissionId === 26);

  permissionAdmin.Clients = {
    selectAll: false,

    viewClients: MapSinglePermissionModelToPermissionAdmin(viewClients, 24, viewMode, groupPermission),


    addClients: MapSinglePermissionModelToPermissionAdmin(addClients, 25, viewMode, groupPermission),


    changeClients: MapSinglePermissionModelToPermissionAdmin(changeClients, 26, viewMode, groupPermission),

  }


  let viewGlobalAlerts = modle.find(p => p?.permissionId === 27);
  let addGlobalAlerts = modle.find(p => p?.permissionId === 28);
  let editGlobalAlerts = modle.find(p => p?.permissionId === 29);
  let deleteGlobalAlerts = modle.find(p => p?.permissionId === 30);
  let viewAddEditDeleteMyAlerts = modle.find(p => p?.permissionId === 62);

  permissionAdmin.ViewGlobalAlerts = {
    selectAll: false,

    viewGlobalAlerts: MapSinglePermissionModelToPermissionAdmin(viewGlobalAlerts, 27, viewMode, groupPermission),


    addGlobalAlerts: MapSinglePermissionModelToPermissionAdmin(addGlobalAlerts, 28, viewMode, groupPermission),


    editGlobalAlerts: MapSinglePermissionModelToPermissionAdmin(editGlobalAlerts, 29, viewMode, groupPermission),


    deleteGlobalAlerts: MapSinglePermissionModelToPermissionAdmin(deleteGlobalAlerts, 30, viewMode, groupPermission),


    viewAddEditDeleteMyAlerts: MapSinglePermissionModelToPermissionAdmin(viewAddEditDeleteMyAlerts, 62, viewMode, groupPermission),

  }



  let viewKiosk = modle.find(p => p?.permissionId === 31);
  let addKiosk = modle.find(p => p?.permissionId === 32);
  let editKiosk = modle.find(p => p?.permissionId === 33);
  let deleteKiosk = modle.find(p => p?.permissionId === 34);

  permissionAdmin.Kiosk = {
    selectAll: false,

    viewKioskConfiguration: MapSinglePermissionModelToPermissionAdmin(viewKiosk, 31, viewMode, groupPermission),


    addKioskConfiguration: MapSinglePermissionModelToPermissionAdmin(addKiosk, 32, viewMode, groupPermission),


    editKioskConfiguration: MapSinglePermissionModelToPermissionAdmin(editKiosk, 33, viewMode, groupPermission),


    deleteKioskConfiguration: MapSinglePermissionModelToPermissionAdmin(deleteKiosk, 34, viewMode, groupPermission),

  }

  permissionAdmin.General.selectAll = permissionAdmin.General.viewEditSystemConfiguration.Selected                           
  && permissionAdmin.General.viewEditLocalization.Selected
  && permissionAdmin.General.dataImportExport.Selected ? true : false
  && (tenantId==1 && isUkgDefaultGroup ? permissionAdmin.General.viewEditLicensing.Selected : true);

  permissionAdmin.Location.selectAll = permissionAdmin.Location.addLocations.Selected
  && permissionAdmin.Location.editLocations.Selected
  && permissionAdmin.Location.activateDeactivateLocations.Selected
  && permissionAdmin.Location.viewLocations.Selected;

  permissionAdmin.ViewAddEditDeleteProductCategory.selectAll = 
  permissionAdmin.ViewAddEditDeleteProductCategory.viewAddEditDeleteProductCategory.Selected;

  permissionAdmin.ProductAndService.selectAll = permissionAdmin.ProductAndService.viewProductsServices.Selected
  && permissionAdmin.ProductAndService.addProductsServices.Selected
  && permissionAdmin.ProductAndService.editProductsAndServices.Selected
  && permissionAdmin.ProductAndService.editBasicProductAndServices.Selected
  && permissionAdmin.ProductAndService.activateDeactivateProductsServices.Selected
  && permissionAdmin.ProductAndService.deleteProductsServices.Selected
  ;


  permissionAdmin.Groups.selectAll = permissionAdmin.Groups.addPermissionGroups.Selected && permissionAdmin.Groups.deletePermissionGroups.Selected
  && permissionAdmin.Groups.editPermissionGroups.Selected
  && permissionAdmin.Groups.viewPermissionGroups.Selected;

  permissionAdmin.Users.selectAll = permissionAdmin.Users.addUsers.Selected
  && permissionAdmin.Users.editUsers.Selected
  && permissionAdmin.Users.deleteUsers.Selected
  && permissionAdmin.Users.viewUsers.Selected;

  permissionAdmin.Clients.selectAll = permissionAdmin.Clients.addClients.Selected
  && permissionAdmin.Clients.changeClients.Selected
  && permissionAdmin.Clients.viewClients.Selected;

  permissionAdmin.ViewGlobalAlerts.selectAll = permissionAdmin.ViewGlobalAlerts.addGlobalAlerts.Selected
  && permissionAdmin.ViewGlobalAlerts.editGlobalAlerts.Selected
  && permissionAdmin.ViewGlobalAlerts.deleteGlobalAlerts.Selected
  && permissionAdmin.ViewGlobalAlerts.viewAddEditDeleteMyAlerts.Selected
  && permissionAdmin.ViewGlobalAlerts.viewGlobalAlerts.Selected;

  permissionAdmin.Kiosk.selectAll = permissionAdmin.Kiosk.viewKioskConfiguration.Selected
  && permissionAdmin.Kiosk.addKioskConfiguration.Selected
  && permissionAdmin.Kiosk.editKioskConfiguration.Selected
  && permissionAdmin.Kiosk.deleteKioskConfiguration.Selected;
  
  
  permissionAdmin.selectAllPermissionAdmin.Selected = permissionAdmin.Users.selectAll && permissionAdmin.Location.selectAll && permissionAdmin.General.selectAll
  && (tenantId == 1 && isUkgDefaultGroup ? permissionAdmin.Clients.selectAll : true) && permissionAdmin.ProductAndService.selectAll && permissionAdmin.Kiosk.selectAll && permissionAdmin.ViewGlobalAlerts.selectAll
  && permissionAdmin.Groups.selectAll && permissionAdmin.ViewAddEditDeleteProductCategory.selectAll
  return permissionAdmin;
}

export function setSelectAllAdminStatus(permissionAdmin: PermissionAdmin): boolean {

  let enabled = checkAdminGeneralStatus(permissionAdmin)
                && checkAdminLocationStatus(permissionAdmin)
                && checkAdminProductCategoryStatus(permissionAdmin)
                && checkAdminProductServicesStatus(permissionAdmin)
                && checkAdminGroupStatus(permissionAdmin)
                && checkAdminUserStatus(permissionAdmin)
                && checkAdminAlertStatus(permissionAdmin)
                && checkAdminKioskStatus(permissionAdmin)

  return enabled;
}

//Check for disabled and un-check fields in each sub category of admin permissions section

function checkAdminGeneralStatus(permissionAdmin: PermissionAdmin): boolean {

  let enabled = false;

  let viewEditSystemConfiguration = !permissionAdmin.General.viewEditSystemConfiguration.Enabled;
  let viewEditLocalization = !permissionAdmin.General.viewEditLocalization.Enabled;
  let dataImport = !permissionAdmin.General.dataImportExport.Enabled;

  if (viewEditSystemConfiguration || viewEditLocalization || dataImport) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}

function checkAdminLocationStatus(permissionAdmin: PermissionAdmin): boolean {

  let enabled = false;

  let viewLocations = !permissionAdmin.Location.viewLocations.Enabled;
  let addLocations = !permissionAdmin.Location.addLocations.Enabled;
  let editLocations = !permissionAdmin.Location.editLocations.Enabled;
  let activateDeactivateLocations = !permissionAdmin.Location.activateDeactivateLocations.Enabled;

  if (viewLocations || addLocations || editLocations || activateDeactivateLocations) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}

function checkAdminProductCategoryStatus(permissionAdmin: PermissionAdmin): boolean {

  let enabled = false;

  let viewAddEditDeleteProductCategory = !permissionAdmin.ViewAddEditDeleteProductCategory.viewAddEditDeleteProductCategory.Enabled;

  if (viewAddEditDeleteProductCategory) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}

function checkAdminProductServicesStatus(permissionAdmin: PermissionAdmin): boolean {

  let enabled = false;

  let viewProductsServices = !permissionAdmin.ProductAndService.viewProductsServices.Enabled;
  let addProductsServices = !permissionAdmin.ProductAndService.addProductsServices.Enabled;
  let editBasicProductAndServices = !permissionAdmin.ProductAndService.editBasicProductAndServices.Enabled;
  let editProductsAndServices = !permissionAdmin.ProductAndService.editProductsAndServices.Enabled;
  let activateDeactivateProductsServices = !permissionAdmin.ProductAndService.activateDeactivateProductsServices.Enabled;
  let deleteProductsServices = !permissionAdmin.ProductAndService.deleteProductsServices.Enabled;

  if (viewProductsServices || addProductsServices || editBasicProductAndServices || editProductsAndServices || activateDeactivateProductsServices || deleteProductsServices) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}

function checkAdminGroupStatus(permissionAdmin: PermissionAdmin): boolean {

  let enabled = false;

  let viewPermissionGroups = !permissionAdmin.Groups.viewPermissionGroups.Enabled;
  let addPermissionGroups = !permissionAdmin.Groups.addPermissionGroups.Enabled;
  let editPermissionGroups = !permissionAdmin.Groups.editPermissionGroups.Enabled;
  let deletePermissionGroups = !permissionAdmin.Groups.deletePermissionGroups.Enabled;

  if (viewPermissionGroups || addPermissionGroups || editPermissionGroups || deletePermissionGroups) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}

function checkAdminUserStatus(permissionAdmin: PermissionAdmin): boolean {

  let enabled = false;

  let viewUsers = !permissionAdmin.Users.viewUsers.Enabled;
  let addUsers = !permissionAdmin.Users.addUsers.Enabled;
  let editUsers = !permissionAdmin.Users.editUsers.Enabled;
  let deleteUsers = !permissionAdmin.Users.deleteUsers.Enabled;

  if (viewUsers || addUsers || editUsers || deleteUsers) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}

function checkAdminAlertStatus(permissionAdmin: PermissionAdmin): boolean {

  let enabled = false;

  let viewGlobalAlerts = !permissionAdmin.ViewGlobalAlerts.viewGlobalAlerts.Enabled;
  let viewAddEditDeleteMyAlerts = !permissionAdmin.ViewGlobalAlerts.viewAddEditDeleteMyAlerts.Enabled;
  let addGlobalAlerts = !permissionAdmin.ViewGlobalAlerts.addGlobalAlerts.Enabled;
  let editGlobalAlerts = !permissionAdmin.ViewGlobalAlerts.editGlobalAlerts.Enabled;
  let deleteGlobalAlerts = !permissionAdmin.ViewGlobalAlerts.deleteGlobalAlerts.Enabled;

  if (viewGlobalAlerts || viewAddEditDeleteMyAlerts || addGlobalAlerts || editGlobalAlerts || deleteGlobalAlerts) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}

function checkAdminKioskStatus(permissionAdmin: PermissionAdmin): boolean {

  let enabled = false;

  let viewKioskConfiguration = !permissionAdmin.Kiosk.viewKioskConfiguration.Enabled;
  let addKioskConfiguration = !permissionAdmin.Kiosk.addKioskConfiguration.Enabled;
  let editKioskConfiguration = !permissionAdmin.Kiosk.editKioskConfiguration.Enabled;
  let deleteKioskConfiguration = !permissionAdmin.Kiosk.deleteKioskConfiguration.Enabled;

  if (viewKioskConfiguration || addKioskConfiguration || editKioskConfiguration || deleteKioskConfiguration) {
    enabled = false;
  } else {
    enabled = true;
  }

  return enabled;
}

export function resetPermissionAdmin(): PermissionAdmin {

  let permissionAdmin = new PermissionAdmin();

  permissionAdmin.selectAllPermissionAdmin = {
    Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
  };

  permissionAdmin.General = {
    selectAll: false,
    dataImportExport: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    editClientURLCode: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    viewEditLicensing: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    viewEditLocalization: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    viewEditSystemConfiguration: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    }
  };

  permissionAdmin.Clients = {
    selectAll: false,
    addClients: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    changeClients: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    viewClients: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    }
  };
  
  permissionAdmin.Groups = {
    selectAll: false,
    addPermissionGroups: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    editPermissionGroups: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    viewPermissionGroups: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    deletePermissionGroups: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    }
  };

  permissionAdmin.Kiosk = {
    selectAll: false,
    addKioskConfiguration: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    deleteKioskConfiguration: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    editKioskConfiguration: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    viewKioskConfiguration: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    }
  };

  permissionAdmin.Location = {
    selectAll: false,
    activateDeactivateLocations: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    addLocations: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    editLocations: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    viewLocations: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    }
  };

  permissionAdmin.Members = {
    selectAll: false,
    importMembers: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    viewMembers: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    }
  };

  permissionAdmin.ProductAndService = {
    selectAll: false,
    activateDeactivateProductsServices: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    addProductsServices: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    deleteProductsServices: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    editBasicProductAndServices: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    editProductsAndServices: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    viewProductsServices: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    }
  };

  permissionAdmin.Users = {
    selectAll: false,
    addUsers: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    deleteUsers: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    editUsers: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    viewUsers: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    }
  };

  permissionAdmin.ViewAddEditDeleteProductCategory = {
    selectAll: false,
    viewAddEditDeleteProductCategory: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    }
  };

  permissionAdmin.ViewGlobalAlerts = {
    selectAll: false,
    addGlobalAlerts: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    deleteGlobalAlerts: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    editGlobalAlerts: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    viewAddEditDeleteMyAlerts: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    },
    viewGlobalAlerts: {
      Id: 0,
      Enabled: false,
      Selected: false,
      DisplayName: ''
    }
  };

  return permissionAdmin;
}